import validation from './validation';
export default {
  ...validation,
  sender_name: 'Yuboruvchi ismi',
  sender_wallet: 'Yuboruvchi hamyoni',
  last_n_digits: 'Tranzaksiya havolasi',
  invoice_flow__card_transfer_button: 'Tasdiqlash',
  invoice_flow__multi_bank_transfer_step_1: 'Rekvizitlarni usxalash',
  invoice_flow__card_transfer_step_2:
    "Belgilangan miqdorni o'tkazing (bank, o'z-o'ziga xizmat ko'rsatish terminalidan foydalaning yoki eng yaqin bank filialiga murojaat qiling)",
  invoice_flow__card_transfer_step_3:
    "Tasdiqlash uchun ma'lumotlarni ko'rsating: tavsif, kvitansiya",
  invoice_flow__card_transfer_step_4:
    'O’tkazma muvaffaqiyatli tugagandan so\'ng - <b>"Tasdiqlash"</b> tugmasini bosing.',
};
